import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {
  createCatalogue,
  deleteCatalogue,
  getCatalogueById,
  getCatalogueList,
  updateCatalogue,
} from '../../services/CatalogueService'

interface GetCatalogueListParams {
  pageNumber: number
  pageSize: number
  filterkey: any
}

interface CatalogueState {
  CatalogueList: any
  catalogue: any
}

const initialState: CatalogueState = {
  CatalogueList: null,
  catalogue: null,
}

// Fetch Catalogue list
export const getCatalogueListApi = createAsyncThunk(
  'catalogue/getCatalogueList',
  async ({pageNumber, pageSize, filterkey}: GetCatalogueListParams, {rejectWithValue}) => {
    try {
      const result = await getCatalogueList(pageNumber, pageSize, filterkey)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Fetch catalogue by ID
export const getCatalogueByIdApi = createAsyncThunk(
  'catalogue/getCatalogueById',
  async (id: any, {rejectWithValue}) => {
    try {
      const result = await getCatalogueById(id)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Create a new catalogue
export const createCatalogueApi = createAsyncThunk(
  'catalogue/createCatalogue',
  async (payload: any, {rejectWithValue}) => {
    try {
      const result = await createCatalogue(payload)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Update catalogue
export const updateCatalogueApi = createAsyncThunk(
  'catalogue/updateCatalogue',
  async ({id, payload}: {id: any; payload: any}, {rejectWithValue}) => {
    try {
      const result = await updateCatalogue(id, payload)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Delete catalogue
export const deleteCatalogueApi = createAsyncThunk(
  'catalogue/deleteCatalogue',
  async (id: any, {rejectWithValue}) => {
    try {
      const result = await deleteCatalogue(id)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

const CatalogueSlice = createSlice({
  name: 'catalogue',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getCatalogueListApi.fulfilled, (state, action) => {
        state.CatalogueList = action.payload
      })
      .addCase(getCatalogueByIdApi.fulfilled, (state, action) => {
        state.catalogue = action.payload
      })
      .addCase(createCatalogueApi.fulfilled, (state, action) => {
        state.catalogue = action.payload
      })
      .addCase(updateCatalogueApi.fulfilled, (state, action) => {
        state.catalogue = action.payload
      })
      .addCase(deleteCatalogueApi.fulfilled, (state, action) => {
        state.catalogue = null // Assuming after deletion you want to clear the catalogue state
        // Alternatively, you could modify the CatalogueList if necessary.
      })
  },
})

export default CatalogueSlice
